import isEmpty from "lodash/isEmpty";
import { t } from "@/i18n-js/instance";
import { useGetPaywall } from "@circle-react/components/Modals/MemberProfileModal/Billing/Tabs/SubscriptionTab/ChangePlan/hooks/useGetPaywall";
import { Badge } from "@circle-react/components/SettingsApp/Workflows/components/Badge";
import { Typography } from "@circle-react-uikit/Typography";

interface PaywallNameProps {
  id: number;
}

export const PaywallName = ({ id }: PaywallNameProps) => {
  const { data: paywall, isLoading } = useGetPaywall(id);

  if (isLoading) {
    return <Badge isLoading />;
  }

  if (!paywall || isEmpty(paywall)) {
    return (
      <Typography.LabelSm>
        {t("settings.workflows.view.deleted_paywall")}
      </Typography.LabelSm>
    );
  }

  return (
    <Typography.LabelSm>
      {paywall?.name || paywall?.display_name}
    </Typography.LabelSm>
  );
};
